export default "__VITE_ASSET__cvwwdYFc__"